import { Button } from '@cian/ui-kit/button';
import { ModalWindow } from '@cian/ui-kit/modal';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface IThankProps {
  onClose(): void;
  isMobile: boolean;
}

export function Thank({ onClose, isMobile }: IThankProps) {
  return (
    <ModalWindow
      open={true}
      onClose={onClose}
      maxWidth={448}
      title="Заявка отправлена!"
      content={
        <UIText2>
          Теперь ваша заявка доступна риелторам, которые сотрудничают с Циан. В ближайшее время они с вами свяжутся
        </UIText2>
      }
      footer={
        <div className={styles['footer']}>
          <Button onClick={onClose} size={isMobile ? 'M' : 'XS'}>
            Хорошо
          </Button>
        </div>
      }
    />
  );
}
